/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 crystal.glb -k 
*/

import React from 'react'
import { useGLTF, useKTX2 } from '@react-three/drei'
import * as THREE from 'three'

export function CrystalModel(props) {

     const crystalTexture = {
       map: useKTX2(`/Mesh1_Mesh1.019_Bake1_PBR_Diffuse.ktx2`),
       aoMap: useKTX2(`/Mesh1_Mesh1.019_Bake1_PBR_Ambient Occlusion.ktx2`),
       roughnessMap: useKTX2(`/Mesh1_Mesh1.019_Bake1_PBR_Roughness.ktx2`),
       metalnessMap: useKTX2(`/Mesh1_Mesh1.019_Bake1_PBR_Metalness.ktx2`),
       emissiveMap: useKTX2(`/Mesh1_Mesh1.019_Bake1_PBR_Emission.ktx2`),
       alphaMap: useKTX2(`/Mesh1_Mesh1.019_Bake1_PBR_Alpha.ktx2`),
     }
  const { nodes, materials } = useGLTF('/crystal.glb')
  return (
    <group
      {...props}
      dispose={null}
      rotation={[(Math.PI * 0) / 180, (Math.PI * 120) / 180, (Math.PI * 2) / 180]}
    >
      <mesh
        name="Mesh1_Mesh1019"
        geometry={nodes.Mesh1_Mesh1019.geometry}
        material={nodes.Mesh1_Mesh1019.material}
        transparent
      >
        <meshStandardMaterial
          side={THREE.DoubleSide}
          map={crystalTexture.map}
          map-flipY={false}
          aoMap={crystalTexture.aoMap}
          aoMap-flipY={false}
          roughnessMap={crystalTexture.roughnessMap}
          roughnessMap-flipY={false}
          metalnessMap={crystalTexture.metalnessMap}
          metalnessMap-flipY={false}
          emissiveMap={crystalTexture.emissiveMap}
          emissiveMap-flipY={false}
          emissive={'#3A1C4D'}
          emissiveIntensity={3}
          toneMapped={false}
          alphaMap={crystalTexture.alphaMap}
          alphaMap-flipY={false}
          blendAlpha={10}
          transparent
          castShadow
          receiveShadow
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/crystal.glb')
